import "./grid.scss";
/*
(function () {
	document.addEventListener("DOMContentLoaded", () => {
		document.querySelectorAll(".block-grid").forEach((grid) => {
			const cols = grid.classList.contains("three") ? 3 : 2;
			// You could add fancier front-end behavior here later (animation, filtering, etc.)
			console.log(`[grid] initialized: ${cols} columns`);
		});
	});
})();
 */
